import { createApi } from '@stilingue/st-auth-utils';
import { error401Handler } from '@/utils/error';
import Service from './Service';
import { StFeatureFlagFlags } from '@/plugins/rollout';
import { isProdVersion } from '@stilingue/st-environment-controller-utils';
import Cookies from 'js-cookie';

const afterParser = (response) => {
  return response.data;
};

const isStaging = !isProdVersion();

const gatewayProd = StFeatureFlagFlags.gatewayProd.getValue();
const gatewayStaging = StFeatureFlagFlags.gatewayStaging.getValue();

const version = !isStaging
  ? 'prod'
  : 'staging';
const gateway = !isStaging
  ? gatewayProd
  : gatewayStaging;

class SheetImporterService extends Service {
  constructor(gateway, version) {
    const api = createApi(`/importer-service/${version}/v2/importer/register/sheet/xlsx?`, gateway, {
      authNotFound: () => true,
      error401Handler,
    });
    super(api, { afterParser });

    this.api.http.defaults.timeout = 300000;
  }

  commentSheetImporter(formdata, queryString) {
    const config = {
      params: queryString,
    };
    const headers = {
      'stilingue-session-id': Cookies.get('stilingue-session-id'),
      'Content-Type': 'multipart/form-data',
    };
    return this.update(formdata, config, { headers });
  }
}

export default new SheetImporterService(gateway, version);
